import { Model } from '../core/base.model';
import { Employee } from '../employee/employee.model';

export class VacationYtdAdjustment extends Model {
    protected static _resource = 'payroll/adjustments';

    protected static _version = 'v2';

    get dateLastAdjusted(): string {
        return this._attributes['dateLastAdjusted'];
    }

    get lastAdjustmentAmount(): string {
        return this._attributes['lastAdjustmentAmount'];
    }

    get latestTimeOffYtdBalance(): string {
        return this._attributes['latestTimeOffYtdBalance'];
    }

    get employee(): Employee {
        return this.hasOne(Employee, 'employee');
    }
}
